module.exports = __webpack_public_path__ + "img/pccontactus.5e59ec06.svg";